const optionalDisplayOptions = [
  //{ value: '0', label: 'Select'},
  { value: '1', label: 'Acute Rheumatic Heart Disease' },
  { value: '2', label: 'Cerebral Palsy'},
  { value: '3', label: 'Chromosomal Abnormalities'},
  { value: '4', label: 'Internal Organ Injury'},
]

export default optionalDisplayOptions
